
































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

/**
 * Helpers
 */
import { getFullName } from "@/utils/users-helpers";
import { getDateString, sortByDate, addMinutes, smartDisplayMinutes, getShortTimeString } from "@/utils/date-helpers";

/**
 * Components
 */
import { FilterModel } from "@/components/_global/FilterControl.vue";

/**
 * Types
 */
export interface CalendarTimedEvent {
	title: string;
	date: string;
	time: string;
	duration: number;

	isDisabled: boolean;
	isReserved: boolean;
	isEditable: boolean;
	isReadable: boolean;
	isWaitingForSynchronization: boolean;

	color: string;
	cursor?: string;

	customData?: any;
}


/**
 * Composant de calendrier d'une ressource.
 */
@Component
export default class Calendar extends Vue {
	/** Injections */
	getShortTimeString = getShortTimeString;
	getDateString = getDateString;

	/** Propriétés */
	@Prop({ default: 'fr-FR' })
	locale!: string;

	@Prop({ default: 0 })
	minHour!: number;

	@Prop({ default: 23 })
	maxHour!: number;

	@Prop({ default: 1 })
	zoom!: number;

	@Prop({ default: 60 })
	intervalMinutes!: number;

	@Prop({ default: getDateString(new Date()) })
	currentDate!: string;

	@Prop({ default: [] })
	events!: CalendarTimedEvent[];

	@Prop({ default: 'day' })
	displayType!: string;

	/** Attributs */
	today = getDateString(new Date());
	window = {
		width: 0,
		height: 0
	};

	get maxHeight() {
		return Math.max(this.window.height - 350, 500);
	}

	get eventsMap() {
		const map: any = {};
		this.events.forEach((e) => (map[e.date] = map[e.date] || []).push(e));
		return map;
	}

	get intervalCount() {
		return (this.maxHour - this.minHour + 2) * 60 / this.intervalMinutes;
	}

	get intervalHeight() {
		return this.zoom * this.maxHeight / this.intervalCount;
	}

	get globalEventFontSize() {
		// return Math.max(Math.min(this.intervalHeight * Math.min(...this.events.map((e) => e.duration)) / 60, 14), 14);
		return 12;
	}

	/** Méthodes */
	created() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	}
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	}
	handleResize() {
		this.window.width = window.innerWidth;
		this.window.height = window.innerHeight;
	}

	showIntervalLabel(interval: any) {
		return interval.minute % 60 === 0 && interval.hour >= this.minHour;
	}
	intervalStyle(interval: any) {
		const inactive =
			interval.hour < this.minHour ||
			interval.hour >= this.maxHour;
		const startOfHour = interval.minute === 0;
		const mid = 'rgba(0,0,0,0.1)';

		return {
			backgroundColor: inactive ? 'rgba(0,0,0,0.05)' : 'rgba(0,0,0,0.05)',
			borderTop: startOfHour ? undefined : '1px dashed ' + mid
		};
	}

	onEventClick(event: CalendarTimedEvent) {
		this.$emit('onEventClick', event);
	}
}
